<script>
import { onDestroy } from 'svelte';
import { linear, quintOut } from 'svelte/easing';
import { pusher } from './store';

export let showId;
export let reactionMapping;

let channel;
let reactions = []
let index = 0;
let ignoreSet = {}

onDestroy(() => {
  channel?.unbind();
})

function rebind() {
  channel?.unbind();
  channel = pusher.subscribe(`react-${showId}`);
  channel.bind('react', key => {
    // Ignore unknown reactions
    if (!reactionMapping[key]) return;

    if (ignoreSet[key] > 0) {
      ignoreSet[key]--;
      return;
    }
    add(key)
  });
}

export function add(key, ignoreNext) {
  if (ignoreNext) {
    if (!ignoreSet[key]) {
      ignoreSet[key] = 0
    }
    ignoreSet[key]++;
  }

  if (reactions.length > 50) return;
  reactions = [...reactions, {reaction: reactionMapping[key], index: index++}]
}

$: rebind(showId)
	
function bubble(node, { distance = -200, f = 8, amp = 10, duration = 1300 }) {
	const start = Math.random()
  return {
    duration,
    css: t => {
      const eased = linear(t);
      const opacity = quintOut(1 - t);

      return `
        transform: translate(${Math.sin(eased * f + start * Math.PI) * amp}px, ${eased * distance}px) scale(${Math.sin(t * Math.PI) * .4 + 1});
        opacity: ${opacity};
      `
    }
  };
}
</script>

{#each reactions as {reaction, index}(index)}
  <div class="bubble" in:bubble on:introend={() => reactions = reactions.filter(r => r.index !== index)}>
    {@html reaction}
  </div>
{/each}

<style>
.bubble {
  position: absolute;
  font-size: 24px;
}
</style>